import React from "react";
import { ProgressTracker, ProgressTrackerItem } from "@flixbus/honeycomb-react";
import styles from "./WizardProgress.module.scss";
import type { WizardProgressProps } from "./WizardProgress.types";

const STEP_LABELS = ["Metadata", "Category", "Dimension"];

const WizardProgress: React.FC<WizardProgressProps> = ({ currentStep }) => (
  <div className={styles.progressTracker}>
    <ProgressTracker stretch>
      {STEP_LABELS.map((label, i) => {
        const isLast = i === STEP_LABELS.length - 1;
        const state =
          currentStep > i ? "done" : currentStep === i ? "current" : "pending";
        return (
          <ProgressTrackerItem
            // state in key forces remount — Honeycomb NavItem calls
            // hooks conditionally on current/completed props.
            key={`${label}-${state}`}
            Elem="span"
            current={currentStep === i}
            completed={currentStep > i}
            srOnly={currentStep > i ? "completed" : undefined}
            extraClasses={[
              styles.progressTrackerItem,
              isLast ? styles.progressTrackerItemLast : "",
            ]
              .filter(Boolean)
              .join(" ")}
          >
            {label}
          </ProgressTrackerItem>
        );
      })}
    </ProgressTracker>
  </div>
);

export default React.memo(WizardProgress);
